import { render, staticRenderFns } from "./shrinkable-menu.vue?vue&type=template&id=1d206b0c&"
import script from "./shrinkable-menu.vue?vue&type=script&lang=js&"
export * from "./shrinkable-menu.vue?vue&type=script&lang=js&"
import style0 from "./shrinkable-menu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports